import { ErrorMessage, Field, useFormikContext } from 'formik';
import React, { useEffect, useRef } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { BsClock } from 'react-icons/bs';
import { FormLabel } from '../../forms';
import './TimeField.css';

interface SearchFieldProps {
  name: string;
  label: string;
  isInvalid?: boolean;
  disabled?: boolean;
  defaultValue?: string;
  className?: string;
  onBlur?: () => void;
  onValueChange?: (value: string) => void;
  required?: boolean;
}

export const TimeField: React.FC<SearchFieldProps> = ({
  name,
  label,
  isInvalid,
  disabled,
  defaultValue,
  className,
  onBlur,
  onValueChange,
  required
}) => {
  const timeInputRef = useRef<HTMLInputElement>(null);
  const { setFieldValue, values } = useFormikContext<any>();

  // Set default value if it's not already set
  useEffect(() => {
    if (defaultValue && !values[name]) {
      setFieldValue(name, defaultValue);
    }
  }, [defaultValue, name, setFieldValue, values]);

  return (
    <Form.Group
      controlId={name}
      className="w-100"
    >
      <FormLabel required={required}>{label}</FormLabel>
      <InputGroup className="flex-nowrap time-field-input-group">
        {!disabled && (
          <InputGroup.Text
            style={{ cursor: 'pointer' }}
            onClick={() => timeInputRef?.current?.showPicker()}
          >
            <BsClock />
          </InputGroup.Text>
        )}
        <Field name={name}>
          {({ field }: { field: any }) => (
            <Form.Control
              type="time"
              {...field}
              ref={timeInputRef}
              disabled={disabled}
              isInvalid={isInvalid}
              className={className}
              aria-required={required || undefined}
              onChange={(e) => {
                setFieldValue(name, e.target.value);
                onValueChange?.(e.target.value);
              }}
              onBlur={(e) => {
                field.onBlur(e);
                onBlur?.();
              }}
            />
          )}
        </Field>
      </InputGroup>

      <ErrorMessage
        name={name}
        component="span"
        className="text-danger fs-small"
      />
    </Form.Group>
  );
};
